module.exports = __webpack_public_path__ + "img/database-img.fea64dcb.png";